import { styled } from '@mui/material/styles';
import { IconButton } from '@mui/material';
import { NODE_LABEL_DEFAULT_COLOR, SEQUENCE_NODE_WIDTH } from "../stylingConstants";

interface NodeContainerProps {
    selected: boolean;
}

export const NodeContainer = styled('div')<NodeContainerProps>(({ selected }) => ({
    width: SEQUENCE_NODE_WIDTH,
    background: "rgba(255, 255, 255, 0.8)",
    border: selected ? "1px solid #000000" : "none",
    boxShadow: "0px 2px 10px -4px rgba(0, 0, 0, 0.6)",
    borderRadius: "15px",
    cursor: "pointer",
    minWidth: "180px",
    height: "auto",
    paddingBottom: "6px",
    position: "relative",
    userSelect: "none",
    boxSizing: "border-box",
    contentVisibility: "auto",
    contain: "layout paint style",
    containIntrinsicSize: "auto 336px auto 292px"
}));

interface HeaderContainerProps {
    labelColor: string | null;
}

export const HeaderContainer = styled('div')<HeaderContainerProps>(({ labelColor }) => ({
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    padding: "8px 24px 8px 0px",
    borderTopLeftRadius: "15px",
    borderTopRightRadius: "15px",
    gap: "16px",
    backgroundColor: labelColor || NODE_LABEL_DEFAULT_COLOR
}));

export const NameContainer = styled('div')({
    display: "flex",
    flex: "1",
    alignSelf: "stretch",
    marginLeft: "8px"
});

export const NameText = styled('div')({
    display: "flex",
    alignItems: "center",
    width: "100%",
    fontSize: "1.125rem",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
});

export const StyledIconButton = styled(IconButton)({
    border: "1px solid #000"
});

export const StyledIcon = styled('span')({
    color: "#000"
}); 